import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Loader2, Check } from "lucide-react";

const CF_RX = /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/;

// Inserimento rapido del codice fiscale direttamente dalla scheda di costo.
export function CfQuickInput({ leadId, onUpdate }) {
  const [cf, setCf] = useState("");
  const [saving, setSaving] = useState(false);
  const val = cf.replace(/\s/g, "").toUpperCase();
  const valid = CF_RX.test(val);
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/leads/${leadId}/codice-fiscale`, { codice_fiscale: val });
      onUpdate(data);
      toast.success("Codice fiscale salvato");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2" data-testid="cf-quick-input">
      <Input value={cf} onChange={(e) => setCf(e.target.value.toUpperCase())} maxLength={16} placeholder="Codice fiscale (16 caratteri)" className="h-9 w-64 font-mono uppercase" data-testid="cf-quick-field" />
      <Button size="sm" onClick={save} disabled={!valid || saving} data-testid="cf-quick-save">
        {saving ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Check className="h-4 w-4 mr-1.5" />} Salva
      </Button>
      {val.length === 16 && !valid && <span className="text-[11px] text-destructive" data-testid="cf-quick-error">Formato non valido</span>}
    </div>
  );
}
